import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
import { SearchByMRNIdentifiedPatientResults, SearchByMRNPatientResults, SearchByMRNPatientResultsWithoutConsents, } from "healthex-common/search.dtos";
import { plainToInstance } from "class-transformer";
export class MRNSearchService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async searchByMRNAndGetPatientDetails(orgId, input) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/search-by-mrn/${orgId}`, input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(SearchByMRNPatientResults, response.data);
    }
    async searchByMRNAndGetPatientDetailsWithoutConsents(orgId, input) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/patient-details-by-mrn/${orgId}`, input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(SearchByMRNPatientResultsWithoutConsents, response.data);
    }
    async searchByMRNAndGetIdentifiedPatientDetails(orgId, input) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/search-by-mrn/identified-patients/${orgId}`, input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(SearchByMRNIdentifiedPatientResults, response.data);
    }
}
